import { useState } from "react"
import EditUserModal from "./EditUserModal"
import { toast } from "react-toastify"
import { activateUser, deleteUser, fullActivateUser, fullSuspendUser, suspendUser } from "../../services/userApis"
import MyModal from "../MyModal"

const UserMoreModal = ({ user }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <button onClick={toggleModal}>
                <img className="w-5 h-5" src="assets/icons/gear-complex.svg" />
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="800px" height="500px">
                <div className="grid grid-cols-3">
                    <div className="col-span-2 m-9">
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>نام کاربری</a>
                            <a className="float-left text-blue-400">{user.username}</a>
                        </li>

                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>نقش</a>
                            <a className="float-left text-blue-400">{user.scope}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>وضعیت</a>
                            <a className="float-left text-blue-400">{user.status}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ساخت بات موزیک</a>
                            <a className="float-left text-blue-400">{user.can_use_bot ? "فعال" : "غیرفعال"}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ساخت بات مدیریتی</a>
                            <a className="float-left text-blue-400">{user.can_use_manager_bots ? "فعال" : "غیرفعال"}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ساخت سرور تیم اسپیک</a>
                            <a className="float-left text-blue-400">{user.can_use_servers ? "فعال" : "غیرفعال"}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>ساخت رنک سیستم</a>
                            <a className="float-left text-blue-400">{user.can_use_ranksystems ? "فعال" : "غیرفعال"}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>موجودی</a>
                            <a className="float-left text-blue-400">{user.balance.toLocaleString("en-US")}</a>
                        </li>
                        <li className="py-2 border-t-2 border-slate-700 relative block">
                            <a>نام کمپانی</a>
                            <a className="float-left text-blue-400">{user.company_name}</a>
                        </li>
                        <li className="py-2 border-b-2 border-t-2 border-slate-700 relative block">
                            <a>توضیحات</a>
                            <a className="float-left text-blue-400">{user.info}</a>
                        </li>
                    </div>
                    <div className="col-span-1 flex flex-col mt-5 ml-5 mb-5">
                        <EditUserModal user={user} />

                        {user.status == "suspended" ? (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(activateUser(user.id), {
                                            pending: "در حال فعال کردن کاربر",
                                            success: "فعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border border-green-500 bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                            >
                                فعال کردن کاربر
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                </svg>
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(suspendUser(user.id), {
                                            pending: "در حال غیرفعال کردن کاربر",
                                            success: "غیرفعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border border-yellow-500 bg-yellow-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                            >
                                غیرفعال کردن کاربر
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                </svg>
                            </button>
                        )}
                        {user.status == "suspended" ? (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(fullActivateUser(user.id), {
                                            pending: "در حال فعال کردن کاربر",
                                            success: "فعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border border-green-500 bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
                            >
                                فعال کردن کاربر و سرورها
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                </svg>
                            </button>
                        ) : (
                            <button
                                onClick={() => {
                                    toast
                                        .promise(fullSuspendUser(user.id), {
                                            pending: "در حال غیرفعال کردن کاربر",
                                            success: "غیرفعال شد",
                                            error: "Error",
                                        })

                                        .catch((err) => {
                                            console.error(err)
                                        })
                                }}
                                className="flex justify-center border border-yellow-500 bg-yellow-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-yellow-600 focus:outline-none focus:shadow-outline"
                            >
                                غیرفعال کردن کاربر و سرورها
                                <svg
                                    version="1.1"
                                    id="Capa_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25px"
                                    height="25px"
                                    viewBox="0 0 40 40"
                                    style={{ enableBackground: "new 0 0 40 40" }}
                                >
                                    <rect x="23.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                    <rect x="10.5" style={{ fill: "#424A60" }} width="6" height="30" />
                                </svg>
                            </button>
                        )}
                        <button
                            onClick={() => {
                                toast
                                    .promise(deleteUser(user.id), {
                                        pending: "در حال حذف کردن کاربر",
                                        success: "حذف شد",
                                        error: "Error",
                                    })

                                    .catch((err) => {
                                        console.error(err)
                                    })
                            }}
                            className="flex justify-center border border-red-500 bg-red-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
                        >
                            حذف یوزر
                            <svg
                                version="1.1"
                                id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 50 50"
                                enable-background="new 0 0 50 50"
                            >
                                <path
                                    fill="#231F20"
                                    d="M10.289,14.211h3.102l1.444,25.439c0.029,0.529,0.468,0.943,0.998,0.943h18.933
	c0.53,0,0.969-0.415,0.998-0.944l1.421-25.438h3.104c0.553,0,1-0.448,1-1s-0.447-1-1-1h-3.741c-0.055,0-0.103,0.023-0.156,0.031
	c-0.052-0.008-0.1-0.031-0.153-0.031h-5.246V9.594c0-0.552-0.447-1-1-1h-9.409c-0.553,0-1,0.448-1,1v2.617h-5.248
	c-0.046,0-0.087,0.021-0.132,0.027c-0.046-0.007-0.087-0.027-0.135-0.027h-3.779c-0.553,0-1,0.448-1,1S9.736,14.211,10.289,14.211z
	 M21.584,10.594h7.409v1.617h-7.409V10.594z M35.182,14.211L33.82,38.594H16.778l-1.384-24.383H35.182z"
                                />
                                <path
                                    fill="#231F20"
                                    d="M20.337,36.719c0.02,0,0.038,0,0.058-0.001c0.552-0.031,0.973-0.504,0.941-1.055l-1.052-18.535
	c-0.031-0.552-0.517-0.967-1.055-0.942c-0.552,0.031-0.973,0.504-0.941,1.055l1.052,18.535
	C19.37,36.308,19.811,36.719,20.337,36.719z"
                                />
                                <path
                                    fill="#231F20"
                                    d="M30.147,36.718c0.02,0.001,0.038,0.001,0.058,0.001c0.526,0,0.967-0.411,0.997-0.943l1.052-18.535
	c0.031-0.551-0.39-1.024-0.941-1.055c-0.543-0.023-1.023,0.39-1.055,0.942l-1.052,18.535C29.175,36.214,29.596,36.687,30.147,36.718
	z"
                                />
                                <path
                                    fill="#231F20"
                                    d="M25.289,36.719c0.553,0,1-0.448,1-1V17.184c0-0.552-0.447-1-1-1s-1,0.448-1,1v18.535
	C24.289,36.271,24.736,36.719,25.289,36.719z"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </MyModal>
        </>
    )
}

export default UserMoreModal
